import { combineReducers } from '@reduxjs/toolkit'
import { reducer as settingsReducer } from '../slices/settings'
import { reducer as reportingDashboardReducer } from '../slices/reportingDashboard'
import { reducer as notificationsReducer } from '../slices/notifications'
import { reducer as adminOrganizationsReducer } from '../slices/admin-organizations'
import { reducer as adminOrganizationsBillingProfilesReducer } from '../slices/admin-organization_billing_profiles'
import { reducer as adminOrganizationsUsersReducer } from '../slices/admin-organization-users'
import dataTableReducer from '../slices/data-table.ts'
import { api } from '../services/api/index.ts'
import { laravel_api } from '../services/laravel_api/index.ts'

/**
 * Combines multiple reducers into a single root reducer object.
 *
 * @type {Object}
 * @property {Function} settings - Reducer handling settings state.
 * @property {Function} reportingDashboard - Reducer handling reporting dashboard state.
 * @property {Function} notifications - Reducer managing notifications state.
 * @property {Function} adminOrganizations - Reducer handling admin organizations state.
 * @property {Function} adminOrganizationsBillingProfiles - Reducer for billing profiles in admin organizations.
 * @property {Function} adminOrganizationsUsers - Reducer managing users in admin organizations.
 * @property {Function} dataTable - Reducer for handling data table state.
 * @property {Function} [api.reducerPath] - Reducer provided by the API slice.
 */
export const rootReducer = combineReducers({
    settings: settingsReducer,
    reportingDashboard: reportingDashboardReducer,
    notifications: notificationsReducer,
    adminOrganizations: adminOrganizationsReducer,
    adminOrganizationsBillingProfiles: adminOrganizationsBillingProfilesReducer,
    adminOrganizationsUsers: adminOrganizationsUsersReducer,
    dataTable: dataTableReducer,
    [api.reducerPath]: api.reducer,
    [laravel_api.reducerPath]: laravel_api.reducer
})
